module.exports = __webpack_public_path__ + "static/media/STAF_bokmål med nordsamisk_sentrert logo_neg(hvit).1b8e5c89.pdf";